'use client';

import { useModalStore } from '@/store';
import { asText, Content } from '@prismicio/client';
import { PrismicNextImage, PrismicNextLink } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';

/**
 * Props for `Popup`.
 */
export type PopupProps = SliceComponentProps<Content.PopupSlice>;

/**
 * Component for "Popup" Slices.
 */
const Popup = ({ slice }: PopupProps): JSX.Element => {
  const { title, options } = slice.primary;
  const closeModal = useModalStore((state) => state.closeModal);

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="max-w-screen-2xl mx-auto px-5 md:px-16 py-20">
        <div className="text-center text-white mb-20">
          <p className="text-h1">{asText(title)}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {options.map((option, index) => (
            <div onClick={closeModal} key={`option-${index}`}>
              <PrismicNextLink
                field={option.go_to_page}
                className="p-8 bg-white bg-opacity-20 backdrop-blur-md rounded-[20px] cursor-pointer text-white hover:bg-opacity-30 flex flex-col gap-y-6"
              >
                <PrismicNextImage field={option.icon} />
                <p className="text-regular-semibold">{asText(option.target)}</p>
                <p className="text-h4">{asText(option.pain_point)}</p>
                <PrismicRichText field={option.expertise} />
                <div className="button-outline-white">
                  <span>{option.button_label}</span>
                </div>
              </PrismicNextLink>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Popup;
